import { request } from '@utils';

const getProcurementOrders = async ({ params = {}, payload = {} } = {}) => {
  const body = {
    body: payload,
  };

  const results = await request.post(
    `/v1/procurement/filter?${new URLSearchParams(params)}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getProcurementOrdersSuppliers = async () => {
  const results = await request.get('/v1/procurement/suppliers');

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const createProcurementOrder = async (payload) => {
  const params = {
    body: payload,
  };

  const results = await request.post('/v1/procurement', params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getProcurementOrderSuppliers = async () => {
  const results = await request.get('/v1/procurement/suppliers');

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getProcurementOrderById = async (orderId) => {
  const results = await request.get(`/v1/procurement/${orderId}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateProcurementOrder = async (orderId, params) => {
  const body = {
    body: params,
  };

  const results = await request.patch(`/v1/procurement/${orderId}`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addSkuGroup = async (orderId, payload) => {
  const body = {
    body: payload,
  };

  const results = await request.post(`/v1/procurement/${orderId}/sku`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateSkuGroup = async (orderId, skuId, payload) => {
  const body = {
    body: payload,
  };

  const results = await request.patch(
    `/v1/procurement/${orderId}/sku/${skuId}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const removeSkuGroup = async (orderId, skuId) => {
  const results = await request.remove(
    `/v1/procurement/${orderId}/sku/${skuId}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getWWWVehicles = async () => {
  const results = await request.get('/v1/www/vehicles');

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getSkuGroupDocuments = async (orderId, skuGroupId) => {
  const results = await request.get(
    `/v1/procurement/${orderId}/sku/${skuGroupId}/documents`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addSkuGroupDocument = async (orderId, skuGroupId, payload) => {
  const body = {
    body: payload,
  };

  const results = await request.post(
    `/v1/procurement/${orderId}/sku/${skuGroupId}/documents`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteSkuGroupDocument = async (orderId, skuGroupId, documentId) => {
  const results = await request.remove(
    `/v1/procurement/${orderId}/sku/${skuGroupId}/documents/${documentId}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getSkuGroupComments = async (orderId, skuGroupId) => {
  const results = await request.get(
    `/v1/procurement/${orderId}/sku/${skuGroupId}/comments`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addSkuGroupComment = async (orderId, skuGroupId, payload) => {
  const body = {
    body: payload,
  };

  const results = await request.post(
    `/v1/procurement/${orderId}/sku/${skuGroupId}/comments`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateComment = async (commentId, payload) => {
  const body = {
    body: payload,
  };

  const results = await request.patch(`/v1/comments/${commentId}`, body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteComment = async (commentId) => {
  const results = await request.remove(`/v1/comments/${commentId}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getProcurementEnums = async () => {
  const results = await request.get('/v1/procurement/enums');

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

export {
  getProcurementOrders,
  getProcurementOrdersSuppliers,
  createProcurementOrder,
  getProcurementOrderById,
  updateProcurementOrder,
  getProcurementOrderSuppliers,
  addSkuGroup,
  updateSkuGroup,
  removeSkuGroup,
  getWWWVehicles,
  getSkuGroupDocuments,
  addSkuGroupDocument,
  deleteSkuGroupDocument,
  getSkuGroupComments,
  addSkuGroupComment,
  updateComment,
  deleteComment,
  getProcurementEnums,
};
